/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ToolsetSummary,
  ToolsetSummary$inboundSchema,
} from "./toolsetsummary.js";

export type ListToolsetSummariesResult = {
  /**
   * The list of toolset summaries
   */
  toolsets: Array<ToolsetSummary>;
};

/** @internal */
export const ListToolsetSummariesResult$inboundSchema: z.ZodMiniType<
  ListToolsetSummariesResult,
  unknown
> = z.object({
  toolsets: z.array(ToolsetSummary$inboundSchema),
});

export function listToolsetSummariesResultFromJSON(
  jsonString: string,
): SafeParseResult<ListToolsetSummariesResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListToolsetSummariesResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListToolsetSummariesResult' from JSON`,
  );
}
